module.exports = __webpack_public_path__ + "media/svg-new/warning4-d4541bfa.svg";